import request from '@/router/axios'
import env from '@/config/env'

/**
 * 新增站点管理
 * @param {对象参数} data
 * @returns
 */
export const saveSite = (data) => {
  return request({
    url: env.ferryUrl + '/stationManage/save',
    method: 'POST',
    data: data
  })
}

/**
 * 编辑站点
 * @param {对象参数} data
 * @returns
 */
export const update = (data) => {
  return request({
    url: env.ferryUrl + '/stationManage/update',
    method: 'POST',
    data: data
  })
}

/**
 * 列表
 * @param {查询参数} data
 * @returns
 */
export const list = (data = {}) => {
  return request({
    url: env.ferryUrl + '/stationManage/list',
    method: 'POST',
    data: data
  })
}

/**
 * 删除
 * @param {删除id} id
 * @returns
 */
export const deleted = (id) => {
  return request({
    url: env.ferryUrl + `/stationManage/delete/${id}`,
    method: 'GET'
  })
}

/**
 * 获取详情
 * @param id
 */
export const getInfo= (id) => {
  return request({
    url: env.ferryUrl + `/stationManage/selectById/${id}`,
    method: 'post'
  })
}
